import {InputTypes, ValueTypes, IFieldDefinition, FieldViews} from 'app/interfaces';
import { Validators } from '@angular/forms';
import moment from 'moment';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

fieldsMap.set('url', {
	key: 'url',
	name: 'URL Sito',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

fieldsMap.set('complete_booking_url', {
	key: 'complete_booking_url',
	name: 'URL pagina di pagamento (Date a richiesta)',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING,
	inputConfig: {
		type: InputTypes.TEXT,
		hint: 'Pagina del sito con il widget <tangerine-complete-booking>. Se vuoto si usa la pagina del plugin WordPress (URL Sito + /tc/complete-booking)'
	}
});

fieldsMap.set('scenario', {
	key: 'scenario',
	name: '',
	inputType: InputTypes.HIDDEN,
	valueType: ValueTypes.STRING,
	fieldView: FieldViews.HIDDEN,
	formValidators: [ Validators.required ],
	defaultValue(dataContainerService: IDataContainerService) {
		return 'externalsite';
	}
});

export {fieldsMap as externalsiteFieldsMap};
